export class WorkspaceDatabaseKeys {
	public static readonly schema = 'schema';
	public static readonly columnsKey = 'columns';
	public static readonly tablesKey = 'tables';
	public static readonly referenceTableKey = 'referencetables';
	public static readonly referenceTableName = 'reference_table_name';
	public static readonly excludedItems = ['START_STUB', 'END_STUB'];
	public static readonly exportExcludedKeys = [
		'rxdbid',
		'rxdbidstring',
		'_id',
		'_attachments',
		'_rev',
		'pk_composed',
		'isDeleted',
		'pendingDelete',
		'importedFromFile'
	];

	public static readonly columns = class {
		public static readonly holeNumber = 'hole_number';
		public static readonly projectNumber = 'project_number';
		public static readonly depthFrom = 'depth_from';
		public static readonly depthTo = 'depth_to';
		public static readonly depth = 'depth';
		public static readonly startDate = 'start_date';
		public static readonly completedDate = 'completed_date';
		public static readonly primaryKeyComposed = 'pk_composed';
		public static readonly columnName = 'column_name';
		public static readonly tableName = 'table_name';
		public static readonly tableId = 'table_id';
		public static readonly separator = '_';
		public static readonly columnLabel = 'column_label';
		public static readonly dataType = 'data_type';
		public static readonly width = 'width';
		public static readonly decimalPlaces = 'decimal_places';
		public static readonly displayOrder = 'display_order';
		public static readonly editStyle = 'edit_style';
		public static readonly defaultValue = 'default_value';
		public static readonly calculationFormula = 'calculation_formula';
		public static readonly isColumnNullable = 'is_column_nullable';
		public static readonly elevation = 'elevation';
		public static readonly inheritValues = 'inherit_values';
		public static readonly tableModule = 'table_module';
		public static readonly displayColumn = 'display_column';
		public static readonly isEditable = 'is_editable';
		public static readonly columnStyle = 'column_style';
		public static readonly codeTableName = 'code_table_name';
		public static readonly codeDisplayColumnName = 'code_display_column_name';
		public static readonly codeDataColumnName = 'code_data_column_name';
		public static readonly minimumValue = 'minimum_value';
		public static readonly maximumValue = 'maximum_value';
		public static readonly isMinor = 'is_minor';
		public static readonly sampleNumber = 'sample_number';
		public static readonly standardNumber = 'standard_number';
		public static readonly dropdownsToSplitByQcOriginal = ['assay_sample_type'];
		public static readonly externalCreatedRecord = 'external_created_record';
		public static readonly externalModifiedRecord = 'external_modified_record';
		public static readonly insertedDepth = 'inserted_depth';
		public static readonly parentSampleNumber = 'parent_sample_number';
		public static readonly isMaster = 'is_master';
		public static readonly status = 'status';
		public static readonly inheritValuesColumn = 'inherit_values_column';
		public static readonly lengthColumn = 'length';
		public static readonly eastWestDecimalColumn = 'eastwest_decimal';
		public static readonly northSouthDecimalColumn = 'northsouth_decimal';
	};

	public static readonly internalColumns = class {
		public static readonly rxdbid = 'rxdbid';
		public static readonly rxdbidstring = 'rxdbidstring';
		public static readonly isDeleted = 'isDeleted';
	};

	public static readonly tables = class {
		public static readonly tableName = WorkspaceDatabaseKeys.columns.tableName;
		public static readonly tableModule = 'table_module';
		public static readonly tabTitle = 'tab_title';
		public static readonly tableId = WorkspaceDatabaseKeys.columns.tableId;
		public static readonly childTableIds = 'child_table_ids';
		public static readonly isIntervalRelated = 'is_interval_related';
		public static readonly allowOverlap = 'allow_overlap';
		public static readonly allowGaps = 'allow_gaps';
		public static readonly allowDups = 'allow_dups';
		public static readonly dataMustStartAtZero = 'data_must_start_at_zero';
		public static readonly defaultRow = 'default_row';
		public static readonly standardTableName = 'standard_table';
		public static readonly sampleTables = ['hole_assay_sample', 'modular_samples'];
		public static readonly drillHole = 'DRILL_HOLE';
	};

	public static readonly referenceTables = class {
		public static readonly originalCategory = 'original';
		public static readonly qcCategory = 'qc';
		public static readonly assaySampleTypeCategory = 'assay_sample_type_category';
		public static readonly assaySampleTypeCode = 'assay_sample_type_code';
		public static readonly assaySampleTypeRefTable = 'assay_sample_type';
		public static readonly assayStandardCode = 'assay_standard_code';
	};
}
